export const ProfessionalRoute = {
  MYTEAM: {
    path: 'myteam',
    name: 'myteam'
  }
};
